<template>
    <v-dialog v-model="dialog" width="800" :retain-focus="false">
        <v-card>
            <v-card-title class="headline">
                Dodaj usługę
            </v-card-title>
            <v-card-text>
                <v-form
                    ref="newForm"
                    v-model="valid"
                    lazy-validation
                    class="dimension--form mt-5 mb-5"
                >
                    <v-row>
                        <v-col cols="12" md="12" align-self="start" dense>
                            <p class="mt-2">Aktywna</p>
                            <v-switch
                                v-model="form.isActive"
                                class="mt-0 pt-0"
                                :label="form.isActive ? 'Tak' : 'Nie'"
                                :persistent-hint="true"
                            ></v-switch>
                            <p class="mt-2">Promowana</p>
                            <v-switch
                                v-model="form.promoted"
                                class="mt-0 pt-0"
                                :label="form.promoted ? 'Tak' : 'Nie'"
                                :persistent-hint="true"
                            ></v-switch>
                            <v-autocomplete
                                v-model="form.type"
                                :items="serviceTypes"
                                item-text="name"
                                item-value="id"
                                label="Typ"
                                :rules="formRules.type"
                            ></v-autocomplete>
                            <v-select
                                v-model="form.vatRate"
                                :items="vatRates"
                                label="Stawka VAT"
                            ></v-select>
                            <v-text-field
                                v-if="form.availableWithTransport"
                                v-model="form.priceWithTransport"
                                class="pt-0"
                                type="number"
                                label="Cena netto"
                                placeholder=" "
                            ></v-text-field>
                            <p class="mt-2">Opis</p>
                            <ckeditor
                                v-if="form.availableWithTransport"
                                v-model="form.availableWithTransportDescription"
                                class="pt-0"
                                hint="Opis"
                                placeholder="Opis"
                                :editor="editor"
                                :config="editorConfig"
                            ></ckeditor>
                            <p class="mt-2">Szczegóły usługi po zamówieniu</p>
                            <ckeditor
                                v-if="form.availableWithTransport"
                                v-model="form.availableWithTransportSummary"
                                class="pt-0"
                                hint="Szczegóły usługi po zamówieniu"
                                placeholder="Szczegóły usługi po zamówieniu"
                                :editor="editor"
                                :config="editorConfig"
                            ></ckeditor>
                            <vue-dropzone id="dropzone" :options="dropzoneOptions"
                                          v-on:vdropzone-success="storeImageId" v-on:vdropzone-removed-file="removeImage"></vue-dropzone>
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click.prevent="onSubmit"
                            type="Submit"
                            class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                            large
                        >Dodaj&nbsp;<v-icon size="24">mdi-send</v-icon>
                        </v-btn
                        >
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";
import transactionTypeMixin from "@/mixins/transactionTypeMixin";
import transportConditionMixin from "@/mixins/transportConditionMixin";
import categoryMixin from "@/mixins/categoryMixin";
import priceMixin from "@/mixins/priceMixin";
import paymentConditionMixin from "@/mixins/paymentConditionMixin";
import dateMixin from "@/mixins/dateMixin";
import validationHelpers from '@/mixins/validationHelpers'
import vue2Dropzone from "vue2-dropzone";
import {Auth} from "../services/Auth";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from '../utils/ckeditor5/build/ckeditor';
import units from "@/mixins/unitMixin";

export default {
    name: 'ModalAddService',
    components: {
        vueDropzone: vue2Dropzone,
        ckeditor: CKEditor.component,
    },
    props: {
        item: {},
    },
    mixins: [
        transactionTypeMixin,
        transportConditionMixin,
        categoryMixin,
        priceMixin,
        paymentConditionMixin,
        dateMixin,
        validationHelpers,
        units
    ],
    created() {
        this.loadPartners();
    },
    data() {
        return {
            partners: null,
            unit: "",
            dialog: false,
            form: {
                partner: null,
                type: '',
                buyType: 'wastePurchase',
                wmRole: null,
                wmPrice: null,
                whoPayForWm: null,
                whoTransport: null,
                unit: 'PIECE',
                availableWithTransport: true,
                availableWithTransportDescription: '',
                availableWithTransportSummary: '',
                priceWithTransport: '',
                availableWithoutTransport: false,
                availableWithoutTransportDescription: '',
                availableWithoutTransportSummary: '',
                priceWithoutTransport: '',
                photosIds: [],
                isSale: true,
                vatRate: null,
                minimumQuantity: null,
                maximumQuantity: null,
                isActive: true,
                promoted: false,
            },
            formRules: {
                type: [(value) => !!value || 'wybierz typ'],
                unit: [(value) => !!value || 'wybierz jednostkę'],
            },
          wmRoles: [
            {value: 'mediation', text: 'Pośrednictwo'},
            {value: 'sell', text: 'Sprzedaż'},
          ],
          feePayer: [
            {value: 'client', text: 'Klient'},
            {value: 'partner', text: 'Partner'},
          ],
            valid: false,
            serviceTypes: [],
            serviceBuyTypes: [
                {value: 'paidUtilization', text: 'Płatna utylizacja'},
                {value: 'wastePurchase', text: 'Kupno odpadu'},
            ],
            whoTransport: [
              {value: null, text: 'Wybierz'},
              {value: 'client', text: 'Klient'},
              {value: 'seller', text: 'Sprzedawca'},
              {value: 'wm', text: 'Wastemaster'},
            ],
            vatRates: [0, 5, 8, 23],
            dropzoneOptions: {
                url: `${process.env.VUE_APP_API_URL}/api/price-list/company-branch/${this.item}/service/images`,
                thumbnailWidth: 150,
                maxFilesize: 1024 * 20,
                maxFiles: 1,
                acceptedFiles: 'image/*',
                addRemoveLinks: true,
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem(Auth.TOKEN_KEY)}`
                }
            },
            editor: ClassicEditor,
            editorConfig: {
                id: this.item,
                htmlSupport: {
                    allow: [
                        {
                            name: /.*/,
                            attributes: true,
                            classes: true,
                            styles: true
                        }
                    ],
                }
            },
        }
    },
    methods: {
        open() {
            this.dialog = true

            this.getServiceTypes();
        },
        async onSubmit() {
            if (!this.$refs.newForm.validate()) {
                return
            }

            const service = {
                partner: this.form.partner,
                type: this.form.type,
                buyType: this.form.buyType,
                wmRole: this.form.wmRole,
                wmPrice: this.form.wmPrice,
                whoPayForWm: this.form.whoPayForWm,
                whoTransport: this.form.whoTransport,
                availableWithTransport: this.form.availableWithTransport ?? false,
                availableWithTransportDescription: this.form.availableWithTransportDescription,
                availableWithTransportSummary: this.form.availableWithTransportSummary,
                priceWithTransport: this.form.priceWithTransport !== ''  ? parseFloat(this.form.priceWithTransport) : null,
                availableWithoutTransport: this.form.availableWithoutTransport ?? false,
                availableWithoutTransportDescription: this.form.availableWithoutTransportDescription,
                availableWithoutTransportSummary: this.form.availableWithoutTransportSummary,
                priceWithoutTransport: this.form.priceWithoutTransport ? parseFloat(this.form.priceWithoutTransport) : null,
                unit: this.form.unit,
                photosIds: this.form.photosIds,
                isSale: this.form.isSale,
                isActive: this.form.isActive,
                promoted: this.form.promoted,
                vatRate: this.form.vatRate,
                minimumQuantity: this.form.minimumQuantity !== '' ? this.form.minimumQuantity : null,
                maximumQuantity: this.form.maximumQuantity !== '' ? this.form.maximumQuantity : null,
            }
            api
                .post('/api/price-list/company-branch/' + this.item + '/service', service)
                .then(() => {
                    this.$root.$emit('notifySuccess', {
                        html: 'Usługa została dodana.',
                    });
                    this.dialog = false;
                    this.form.type = '';
                    this.form.buyType = '';
                    this.form.wmRole = null;
                    this.form.whoTransport = null;
                    this.form.availableWithTransport = true;
                    this.form.availableWithTransportDescription = '';
                    this.form.availableWithTransportSummary = '';
                    this.form.priceWithTransport = '';
                    this.form.availableWithoutTransport = false;
                    this.form.availableWithoutTransportDescription = '';
                    this.form.availableWithoutTransportSummary = '';
                    this.form.priceWithoutTransport = '';
                    this.form.photosIds = [];
                    this.form.isSale = true;
                    this.form.promoted = false;
                    this.form.minimumQuantity = '';
                    this.form.maximumQuantity = '';
                    this.$parent.load();
                })
                .catch((error) => {
                    console.error('Error when adding a dimension:', error);
                    this.$root.$emit('notifyError', {
                        html: 'Wystąpił błąd.',
                    });
                })
        },
        getServiceTypes() {
            api
                .get('/api/price-list/company-branch/' + this.item + '/service/type')
                .then((response) => {
                    this.serviceTypes = [];

                    response.data.forEach(service => {
                        service.name = service.name + ' - ' + service.category;
                        this.serviceTypes.push(service);
                    });
                })
                .catch((error) => {
                    console.error('Error when getting a service types:', error);
                    this.$root.$emit('notifyError', {
                        html: 'Wystąpił błąd.',
                    });
                })
        },
        storeImageId(event, image) {
            this.form.photosIds.push(image.id);
        },
        removeImage() {
            this.form.photosIds = [];
        },
        async loadPartners() {
            api
                .get('/api/companies?partner=true')
                .then((data) => {
                    this.partners = data.data.items;
                })
                .catch((error) => {
                    console.error('Error when loading partners: ', error);
                })
        },
    },
}
</script>

<style scoped></style>
